import script from "./ViewACampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewACampaign.vue?vue&type=script&setup=true&lang=js"

import "./ViewACampaign.vue?vue&type=style&index=0&id=29634559&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29634559"]])

export default __exports__